import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';

import { RESPONSE_ACTION_TYPES } from '../TicketResponseActions/TicketResponseActions.constants';
import { useCreateResponseAction } from '../TicketResponseActions/TicketResponseActions.store';
import type { TicketResponseActionsDialogProps } from './TicketResponseActionsDialog.types';

const TicketResponseActionsDialog = (
  props: TicketResponseActionsDialogProps
) => {
  const {
    open,
    setIsResponseActionDialogOpen,
    keyToInvalidate,
    selectedResponseAction
  } = props;
  const responseActionPayload = selectedResponseAction?.payload ?? null;
  const caseId = responseActionPayload?.case_id;
  const { mutate: runResponseAction } = useCreateResponseAction(
    caseId === undefined ? '' : String(caseId),
    keyToInvalidate
  );

  const responseActionName =
    RESPONSE_ACTION_TYPES[
      selectedResponseAction?.action_type as keyof typeof RESPONSE_ACTION_TYPES
    ] ??
    (selectedResponseAction?.action_type as string | undefined) ??
    'Unknown Action';

  if (!selectedResponseAction || !responseActionPayload) {
    return null;
  }

  return (
    <Dialog
      maxWidth="sm"
      onClose={() => setIsResponseActionDialogOpen(false)}
      open={open}
    >
      <DialogTitle>Run Response Action - {responseActionName}</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ pt: 2 }}>
          Are you sure you would like to run the following response action:{' '}
          <br />
          <b>{responseActionName}?</b>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setIsResponseActionDialogOpen(false)}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            runResponseAction(responseActionPayload);
            setIsResponseActionDialogOpen(false);
          }}
        >
          Run Response Action
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TicketResponseActionsDialog;
